export default __webpack_public_path__ + "./img/printer.ef8207d46fe11ea59fa62401d82fb664.png";